import Close from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { alpha, InputAdornment, TextField, TextFieldProps, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type SearchProps = TextFieldProps & {
  height?: number,
  onChangeText?: (text: string) => void,
  testID: string,
  width?: number | string,
};

export const Search = ({
  height,
  onChangeText,
  sx,
  testID,
  width,
  ...rest
}: SearchProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment
            position="start"
            sx={{
              paddingBottom: "0px",
              paddingLeft: "0px",
              width: "29px",
            }}
          >
            <SearchIcon fontSize="large" sx={{
              color: theme.palette.text.secondary,
              paddingRight: "8.48px",
            }} />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment
            data-testid={`${testID}-cancel`}
            onClick={() => onChangeText?.("")}
            position="end"
            sx={{
              width: "27px",
            }}>
            <Close
              sx={{
                color: theme.palette.text.secondary,
                cursor: "pointer",
                height: "24px",
                width: "24px",
                visibility: rest.value ? "visible" : "hidden",
              }}
            />
          </InputAdornment>
        ),
      }}
      autoComplete="off"
      inputProps={{
        "data-testid": testID,
      }}
      onChange={(event) => onChangeText?.(event.target.value)}
      placeholder={t($ => $.common.search.placeholder)}
      sx={{
        backgroundColor: alpha('#000000', 0.06),
        borderRadius: "28px",
        height: height ? height : undefined,
        maxWidth: width ? width : undefined,
        minWidth: width ? width: undefined,
        '& .MuiInputBase-input::placeholder': {
          color: theme.palette.text.primary,
          opacity: 1,
        },
        ...sx,
      }}
      variant="standard"
      {...rest}>
    </TextField>
  );
};
